import { React } from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import MainLayout from './components/Layout/MainLayout';
import ProfileLayout from './components/Layout/ProfileLayout';
import {
  EditUserProfile,
  ViewUserProfile,
  GlobalPage,
  ToolsPage,
  StackPage,
  MitrePage,
  ConfigPage,
  MainTabs,
  SlackChannelPage,
  MSTeamsChannelPage,
  DocViewPage,
  SearchResultPage,
} from './pages';
import NotificationIntegration from './components/Notification/NotificationIntegration';
import RouteChangeListener from './components/RouteChangeListener';
import AdvanceSearchPage from './pages/AdvanceSearchPage';

const AppRouter = () => {
  return (
    <Router>
      <RouteChangeListener />
      <Routes>
        {/* Main application routes with tabs */}
        <Route path='/' element={<MainLayout />}>
          <Route index element={<Navigate to='/global/news' replace />} />
          <Route element={<MainTabs />}>
            <Route path='global'>
              <Route index element={<Navigate to='/global/news' replace />} />
              <Route path='news' element={<GlobalPage />} />
              <Route path='cve' element={<GlobalPage />} />
              <Route path='podcasts' element={<GlobalPage />} />
              <Route path='workspaces' element={<GlobalPage />} />
            </Route>

            <Route path='tools'>
              <Route index element={<Navigate to='/tools/news' replace />} />
              <Route path='news' element={<ToolsPage />} />
              <Route path='cve' element={<ToolsPage />} />
              <Route path='podcasts' element={<ToolsPage />} />
              <Route path='workspaces' element={<ToolsPage />} />
            </Route>

            <Route path='stack'>
              <Route index element={<Navigate to='/stack/news' replace />} />
              <Route path='news' element={<StackPage />} />
              <Route path='cve' element={<StackPage />} />
              <Route path='podcasts' element={<StackPage />} />
              <Route path='workspaces' element={<StackPage />} />
            </Route>

            <Route path='mitre' element={<MitrePage />} />
            <Route path='config' element={<ConfigPage />} />
            <Route path='config/slack' element={<SlackChannelPage />} />
            <Route path='config/msteams' element={<MSTeamsChannelPage />} />
            <Route path='slack' element={<SlackChannelPage />} />
            <Route path='msteams' element={<MSTeamsChannelPage />} />
            <Route path='notifications' element={<NotificationIntegration />} />
          </Route>

          {/* Special routes that don't use tabs */}
          <Route
            path='doc-view/:repositoryId/:documentId'
            element={<DocViewPage />}
          />

          <Route path='search-result' element={<SearchResultPage />} />
          <Route path='advanced-search' element={<AdvanceSearchPage />} />

          <Route
            path='onboard'
            element={<div>Onboard component placeholder</div>}
          />
        </Route>

        {/* Profile routes with separate layout */}
        <Route path='/' element={<ProfileLayout />}>
          <Route path='profile' element={<ViewUserProfile />} />
          <Route path='profile/edit' element={<EditUserProfile />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
